// @flow
import React from 'react';

import CircularProgress from '@material-ui/core/CircularProgress';
import Fade from '@material-ui/core/Fade';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import classNames from 'classnames';

const styles = (theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    alignContent: 'center',
    height: '100%',
  },
  progress: {
    color: theme.palette.primary.main,
    margin: 20,
  },
});

type Props = {
  size?: Number,

  // from withStyles
  classes: Object,
  style: Object,
  circularProgressStyle: Object,
  children?: React.Node,
  title?: string,
  subTitle?: string,
  id: string,
};

const LoadingView = (props: Props) => {
  const { classes, size, style, circularProgressStyle } = props;

  return (
    <div
      className={classNames(classes.root)}
      style={style}
      id={props.id}
    >
      <Fade
        in
        timeout={800}
        unmountOnExit
      >
        <>
          <CircularProgress
            className={classes.progress}
            size={size}
            style={circularProgressStyle}
          />

          {props.title &&
          <Typography variant="h6">
            {props.title}
          </Typography>
          }

          {props.subTitle &&
          <Typography variant="subtitle2">
            {props.subTitle}
          </Typography>
          }

          {props.children}
        </>
      </Fade>
    </div>
  );
};

LoadingView.defaultProps = {
  size: 40,
};

export default withStyles(styles)(LoadingView);
